/**
 * WLanguageVersions — polskie tłumaczenia.
 *
 * Nazwy języków (Polski/English/Deutsch) NIE są tu — pochodzą z backendu
 * (`content.items[].name`, per locale, źródło: `imp_language`).
 *
 * `currentLanguageAria(name)` — pełny aria-label dla trigger'a dropdown'a,
 * substituuje nazwę aktualnego języka.
 */
import type { DeepString } from "@/lib/i18n";

export const pl = {
  empty: "Brak skonfigurowanych języków.",
  ariaLabel: "Wybór języka",
  /** Aria-label dla button trigger'a w trybie dropdown. */
  currentLanguageAria: (name: string) =>
    `Aktualny język: ${name}. Kliknij aby zmienić.`,
} as const;

export type WLanguageVersionsTranslations = DeepString<typeof pl>;
